// WorkerSearchBar.jsx
import React, { useState } from "react";
import { Search, Phone, User } from "lucide-react";

const WorkerSearchBar = ({
  onSearch,
  isSearching = false,
  placeholder = "Search by name or phone number..."
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [searchType, setSearchType] = useState("phone");

  const handleSearch = () => {
    if (searchQuery.trim()) {
      onSearch(searchQuery.trim(), searchType);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <div className="w-full max-w-md mx-auto">
      {/* Search Type Toggle */}
      <div className="flex border-b border-gray-200 bg-gray-50 rounded-t-lg">
        <button
          className={`
            flex-1 flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium transition-all
            ${searchType === "phone" 
              ? "bg-white text-teal-600 border-b-2 border-teal-600" 
              : "text-gray-600 hover:text-gray-800 hover:bg-gray-100"
            }
          `}
          onClick={() => setSearchType("phone")}
        >
          <Phone size={16} strokeWidth={2} />
          <span>Phone</span>
        </button>
        
        <button
          className={`
            flex-1 flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium transition-all
            ${searchType === "name" 
              ? "bg-white text-teal-600 border-b-2 border-teal-600" 
              : "text-gray-600 hover:text-gray-800 hover:bg-gray-100"
            }
          `}
          onClick={() => setSearchType("name")}
        >
          <User size={16} strokeWidth={2} />
          <span>Name</span>
        </button>

        <button
          className={`
            flex-1 flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium transition-all
            ${searchType === "workerCode" 
              ? "bg-white text-teal-600 border-b-2 border-teal-600" 
              : "text-gray-600 hover:text-gray-800 hover:bg-gray-100"
            }
          `}
          onClick={() => setSearchType("workerCode")}
        >
          <User size={16} strokeWidth={2} />
          <span>Worker Code</span>
        </button>
      </div>

      {/* Search Input */}
      <div className="flex items-center border border-t-0 border-gray-200 rounded-b-lg bg-white">
        <input
          type="text"
          className="flex-1 px-4 py-2.5 text-gray-700 placeholder-gray-400 focus:outline-none rounded-l-lg"
          placeholder={placeholder}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onKeyPress={handleKeyPress}
          disabled={isSearching}
        />
        
        <button
          className={`
            px-4 py-2.5 transition-colors rounded-r-lg
            ${searchQuery.trim() && !isSearching 
              ? "text-teal-600 hover:text-teal-700 hover:bg-gray-50" 
              : "text-gray-400 cursor-not-allowed"
            }
          `}
          onClick={handleSearch}
          disabled={isSearching || !searchQuery.trim()}
        >
          {isSearching ? (
            <svg className="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
            </svg>
          ) : (
            <Search size={18} strokeWidth={2} />
          )}
        </button>
      </div>
    </div>
  );
};

export default WorkerSearchBar;